<template>
  <div
    class="hobi-care-calendar-widget-skeleton tw-bg-white tw-flex tw-flex-col"
  >
    <VSkeleton width="211px" height="32px" />
    <VSkeleton
      class="hobi-care-calendar-widget-skeleton__basic tw-mt-2"
      width="211px"
      height="16px"
    />
    <VSkeleton
      class="hobi-care-calendar-widget-skeleton__basic tw-mt-2"
      width="253px"
      height="16px"
    />
    <div
      class="hobi-care-calendar-widget-skeleton__wrapper tw-mt-2 tw-flex tw-justify-between"
    >
      <VSkeleton
        class="hobi-care-calendar-widget-skeleton__child tw-w-24 tw-flex-grow-0"
        width="98px"
        height="24px"
      />
      <VSkeleton
        class="hobi-care-calendar-widget-skeleton__child tw-w-24 tw-flex-grow-0"
        width="98px"
        height="24px"
      />
      <VSkeleton
        class="hobi-care-calendar-widget-skeleton__child tw-w-24 tw-flex-grow-0"
        width="98px"
        height="24px"
      />
    </div>
    <VSkeleton
      class="hobi-care-calendar-widget-skeleton__basic tw-mt-2"
      width="100%"
      height="32px"
    />
  </div>
</template>

<script lang="ts">
import { VSkeleton } from "@openreply/pattern-library";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    VSkeleton,
  },
});
</script>
